/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

/**
 * The element id for the feedback dialog.
 * This is used to find the element in the DOM to bootstrap the feedback package on-demand.
 */
export const FeedbackElementId = "InAppFeedbackElementId";
